import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import { isPorter, porterDeniedPath } from './driverAccess';

export const PorterRoute = ({ component: Component, isAuthenticated, isLoadingUser, user, ...rest }) => {
   return (
      <Route {...rest} render={(props) => {
         if (isLoadingUser) {
            return (
               <div className="text-center mt-6">
                  <ProgressSpinner />
               </div>
            );
         }

         if (!isAuthenticated) {
            return (
               <Redirect
                  to={{
                     pathname: '/login',
                     state: { from: props.location.pathname }
                  }}
               />
            );
         }

         if (!isPorter(user)) {
            return <Redirect to={porterDeniedPath(user)} />;
         }

         return <Component {...props} />;
      }} />
   );
};
